import React from 'react';
import type { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { PERIODIC_PROMOTION_LABEL_KEYS } from '@/app/common/periodicPromotions.ts';
import { BlackBadgeStyled } from '../BaseBadge/styled';

const PeriodicBadge = ({ promotionType }: { promotionType: PROMOTION_TYPES }) => {
  const { t } = useTranslation();
  const labelKey = PERIODIC_PROMOTION_LABEL_KEYS[promotionType];
  if (!labelKey) return null;
  return <BlackBadgeStyled>{t(labelKey)}</BlackBadgeStyled>;
};

export default PeriodicBadge;
